export default __webpack_public_path__ + "media/images/icons/icon-arrow-timeline-4321ca3eb3e275c76e90d3cebb34de0b.svg";